<template>
  <div :class="$style.fileInputWrapper">
    <label
      v-if="label"
      :class="[
        $style.label,
        $style['label-position'],
        $style['label-font'],
        $style['label-color'],
        $style['label-typography'],
      ]"
    >
      {{ label }}
    </label>
    <IconTooltip
      v-if="tooltip && tooltip.text"
      :iconClass="['jc-info-circle', $style.icon]"
    >
      <p>{{ tooltip.text }}</p>
      <IconTooltipReadMore
        v-if="tooltip.kbLink"
        :kbLink="tooltip.kbLink"
      />
    </IconTooltip>
    <p
      v-if="fileName"
      :class="$style.fileName"
    >
      <svg viewBox="0 0 22 25" xmlns="http://www.w3.org/2000/svg" :class="$style.fileIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M20.48 5.301c.516.517.949 1.549.949 2.288v16.072c0 .74-.6 1.339-1.34 1.339H1.34C.6 25 0 24.4 0 23.66V1.34C0 .6.6 0 1.34 0h12.5c.739 0 1.771.432 2.287.949L20.48 5.3zm-6.194-3.404v5.246h5.245c-.083-.237-.209-.474-.307-.572l-4.366-4.367c-.098-.097-.335-.223-.572-.307zm5.357 21.317V8.93h-5.804c-.74 0-1.339-.6-1.339-1.34V1.786H1.786v21.428h17.857z" fill="#161F27"/></svg>
      {{ fileName }}
    </p>
    <input
      id="file"
      ref="input"
      :accept="accept"
      :class="$style.fileInput"
      :multiple="multiple"
      name="file"
      type="file"
      @change="handleValueChange"
    >
    <label
      :class="[$style.fileInputButton, $style.base, $style.defaultStyles]"
      @click="handleLabelClick"
    >
      {{ buttonText }}
    </label>
  </div>
</template>
<script>
import IconTooltip from 'client/components/Tooltip/IconTooltip.vue';
import IconTooltipReadMore from 'client/components/Tooltip/IconTooltipReadMore.vue';

export default {
  name: 'FileInput',

  components: {
    IconTooltip,
    IconTooltipReadMore,
  },

  props: {
    accept: {
      type: String,
      default: '*',
    },
    buttonText: {
      required: true,
      type: String,
    },
    fileName: {
      type: String,
      default: '',
    },
    handleValueChange: {
      required: true,
      type: Function,
    },
    label: {
      default: '',
      type: String,
    },
    multiple: {
      default: false,
      type: Boolean,
    },
    tooltip: {
      default: () => {},
      type: Object,
    },
  },

  methods: {
    handleLabelClick() {
      this.$refs.input.click();
    },
  },
};
</script>
<style module>
@import './css/formFields.css';
@import '../Buttons/FlatActionStyles.css';

.fileIcon {
  height: 16px;
}

.fileInput {
  display: none !important;
}

.fileInputButton {
  display: block;
  margin-bottom: 20px;
  margin-right: 25px;
  max-width: fit-content;
}

.fileName {
  color: initial !important;
  display: block;
  font-weight: 800;
  height: 18px;
  margin: 12px 0 18px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.icon {
  vertical-align: middle;
}
</style>
